import React, { useState } from 'react'
import { Button, CircularProgress } from '@mui/material';
import { useNotify, useListContext, useGetIdentity } from 'react-admin';
import { operationServices } from 'src/services/sales/operation/operation.service';
import { useTranslate } from 'react-admin'
import { Download } from '@mui/icons-material';
import { reservationServices } from 'src/services/sales/reservation/reservation.service';

export const OperationExportButton = () => {
  const { filterValues,sort } = useListContext();
  const notify = useNotify();
  const translate = useTranslate()
  const { identity } = useGetIdentity();
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false)

  const handleExport = async () => {
    setLoading(true);
    const filterBody = {                     
      ...filterValues,
      order_by: sort.field,
      order_type: sort.order
    }
    try {
        const file = await operationServices.exportOperation(filterBody)
        const fileContent = file;

        const blob = new Blob([fileContent], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Operations.csv';
        link.click();
        URL.revokeObjectURL(url);
        notify('ra.message.download_export_success', { type: 'success' });
    }catch(error){
        console.log("err", error)
        notify('ra.message.export_error', { type: 'error' });
    } finally {
        setLoading(false);
        setExportLoading(true)
        setTimeout(()=>{setExportLoading(false)}, 10000)
    } 
  };

  return (
    <Button
      onClick={handleExport}
      disabled={loading || exportLoading}
      startIcon={loading ? <CircularProgress size={20} /> : <Download fontSize='small' />}
      sx={{ lineHeight: '1.5'}}
      size='small'
    >
      {translate('ra.action.export')}
    </Button>
  )
};